import { HttpParams } from '@angular/common/http';

import { CustomHttpParamEncoder } from '../../encoders';

/**
 * Service to add http params to a http request performed by HttpRequestService
 *
 * @export
 */

export class HttpRequestParamsService {
    /** @property httpParams - HttpParams variable with desired query string parameters
     */
    private httpParams: HttpParams;

    /** @property params - The options provided to a HttpClient's request that holds httpParams
     */
    params: { params?: HttpParams };

    constructor() {
        this.httpParams = new HttpParams({ encoder: new CustomHttpParamEncoder() });
        this.params = {};
    }

    /**
     * Set http params
     * @param params - The map with all desired parameters that will be added to query string.
     */
    async setHttpParams(params: Map<string, string>): Promise<void> {
        if (params) {
            await this.resetHttpParams();

            params.forEach((value, key) => (this.httpParams = this.httpParams.set(key, value)));

            this.params = { params: this.httpParams };
        } else {
            this.params = {};
        }

        return new Promise((resolve, reject) => resolve());
    }

    /**
     * Reset http params
     */
    async resetHttpParams(): Promise<void> {
        this.httpParams = new HttpParams({ encoder: new CustomHttpParamEncoder() });
        this.params = {};

        return new Promise((resolve, reject) => resolve());
    }
}

/**
 * Factory to provide the [HttpRequestParamsService]{@link HttpRequestParamsService}
 */
export function PROVIDE_HTTP_REQUEST_PARAMS_SERVICE_FACTORY(): HttpRequestParamsService {
    return new HttpRequestParamsService();
}
